"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.POIProofEventStatus = exports.MerkletreeScanStatus = exports.EngineEvent = void 0;
var EngineEvent;
(function (EngineEvent) {
    EngineEvent["WalletDecryptBalancesComplete"] = "decrypted-balances";
    EngineEvent["ContractNullifierReceived"] = "nullified";
    EngineEvent["UTXOMerkletreeHistoryScanUpdate"] = "utxo-merkletree-history-scan-update";
    EngineEvent["TXIDMerkletreeHistoryScanUpdate"] = "txid-merkletree-history-scan-update";
    EngineEvent["POIProofUpdate"] = "POIProofUpdate";
    EngineEvent["UTXOScanDecryptBalancesComplete"] = "UTXOScanDecryptBalancesComplete";
})(EngineEvent || (exports.EngineEvent = EngineEvent = {}));
var MerkletreeScanStatus;
(function (MerkletreeScanStatus) {
    MerkletreeScanStatus["Started"] = "Started";
    MerkletreeScanStatus["Updated"] = "Updated";
    MerkletreeScanStatus["Complete"] = "Complete";
    MerkletreeScanStatus["Incomplete"] = "Incomplete";
})(MerkletreeScanStatus || (exports.MerkletreeScanStatus = MerkletreeScanStatus = {}));
var POIProofEventStatus;
(function (POIProofEventStatus) {
    POIProofEventStatus["LoadingNextBatch"] = "LoadingNextBatch";
    POIProofEventStatus["InProgress"] = "InProgress";
    POIProofEventStatus["Error"] = "Error";
    POIProofEventStatus["AllProofsCompleted"] = "AllProofsCompleted";
})(POIProofEventStatus || (exports.POIProofEventStatus = POIProofEventStatus = {}));
